import React, {useEffect, useRef} from 'react';
import { connect } from 'react-redux';
import { getHardwareOptions, getSelectedHardwareOption, getCmsContent } from '@/redux/fitting-hardware';

import {
  ReduxStateType,
  HardwareOptionType,
  CmsPageContentType,
  CmsPageContentIdentifier,
} from '@/types/fitting-hardware';

export interface StateProps {
  hardwareOptions: HardwareOptionType[]
  selectedHardwareOption?: HardwareOptionType
  cmsContent: CmsPageContentType
}

const HardwareDetails = ({ hardwareOptions, selectedHardwareOption, cmsContent }: StateProps) => {
  if (hardwareOptions.length <= 0) {
    return null;
  }
  const hardwareOption = selectedHardwareOption || hardwareOptions[0];
  const { name, description, imageUrl } = hardwareOption.cmsContent;
  const imgRef = useRef<HTMLImageElement>(null);
  const intersectionObserverAvailable = "IntersectionObserver" in window

  useEffect(() => {
    if (imgRef.current) {
      if (intersectionObserverAvailable) {
        const lazyImageObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              let lazyImage = entry.target as HTMLImageElement;
              if (lazyImage.dataset.src) {
                lazyImage.src = lazyImage.dataset.src ;
                lazyImageObserver.unobserve(lazyImage);
              } else {
                lazyImage.src = "";
              }
            }
          });
        });

        lazyImageObserver.observe(imgRef.current);
      } else {
        imgRef.current.src = imageUrl.rendered;
      }
    }
  }, [selectedHardwareOption, hardwareOptions])

  return (
    <div className="shop-tile-col" style={{ flexBasis: '38%' }}>
      <article className="article">
        <p>
          <strong className="shop-tile-highlight-text" dangerouslySetInnerHTML={{ __html: cmsContent[CmsPageContentIdentifier.HighlightText] }} />
        </p>
        <h2 className="shop-tile-h2" dangerouslySetInnerHTML={{ __html: name.rendered }} />
        <div className="shop-tile-images">
          {intersectionObserverAvailable ? (
              <img ref={imgRef} className="shop-tile-image-product" data-src={imageUrl.rendered} alt="" />
            ) : (
              <img ref={imgRef} className="shop-tile-image-product" alt="" loading="lazy"/>
            )
          }
        </div>
        <div
          className="body-text"
          style={{ marginTop: '20px' }}
          dangerouslySetInnerHTML={{ __html: description.rendered }}
        />
      </article>
    </div>
  );
};

const mapStateToProps = (state: ReduxStateType): StateProps => ({
  hardwareOptions: getHardwareOptions(state),
  selectedHardwareOption: getSelectedHardwareOption(state),
  cmsContent: getCmsContent(state),
});

export default connect(mapStateToProps)(HardwareDetails);
